import classnames from 'classnames';
import React, { TdHTMLAttributes, ThHTMLAttributes } from 'react';

export function TableHeadTh({
  className,
  children,
  ...props
}: ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th
      className={classnames(
        'border-b border-dl-border bg-dl-raised px-4 py-3 text-left text-sm font-semibold uppercase tracking-wider text-dl-faint',
        className
      )}
      {...props}
    >
      {children}
    </th>
  );
}

export function TableBodyTd({
  className,
  children,
  ...props
}: TdHTMLAttributes<HTMLTableCellElement>) {
  return (
    <td
      className={classnames(
        'border-b border-dl-border px-4 py-3 text-dl-text group-hover:bg-dl-raised',
        className
      )}
      {...props}
    >
      {children}
    </td>
  );
}
